import React from 'react';

const column = (type, size) => {
  return size ? ` ${type}--col-${size}` : '';
};

const isSelfClosingTag = tag => {
  const selfClosingTags = [
    'area',
    'base',
    'br',
    'col',
    'command',
    'embed',
    'hr',
    'img',
    'input',
    'keygen',
    'link',
    'menuitem',
    'meta',
    'param',
    'source',
    'track',
    'wbr'
  ];
  return selfClosingTags.indexOf(tag) > -1;
};

export function Grid({ full, position, children, tagName, className, center, ...props }) {
  const isFull = full ? ' flexgrid--full' : '';
  const isCentered = center ? ' flexgrid--center' : '';
  let isValidTag = false;
  if (tagName) {
    isValidTag = !isSelfClosingTag(tagName);
  }

  const TagName = isValidTag ? tagName : 'div';
  const flexGridPosition = position ? ` flexgrid--${position}` : '';
  return (
    <TagName
      {...props}
      className={`flexgrid${isCentered}${isFull}${flexGridPosition} ${className || ''}`}
    >
      {children}
    </TagName>
  );
}

export function GridItem({
  children,
  xsmall,
  small,
  medium,
  large,
  xlarge,
  tagName,
  className
}) {
  let isValidTag = false;
  if (tagName) {
    isValidTag = !isSelfClosingTag(tagName);
  }

  const TagName = isValidTag ? tagName : 'div';
  const classSelector = className ? className : '';
  return (
    <TagName
      className={`flexgrid__item${column('xsmall', xsmall)}${column(
        'small',
        small
      )}${column('medium', medium)}${column('large', large)}${column(
        'xlarge',
        xlarge
      )} ${classSelector}`}
    >
      {children}
    </TagName>
  );
}
